import { OnInit, OnDestroy } from "@angular/core";
import { FormControl } from "@angular/forms";
import { DateAdapter } from "@angular/material/core";
import { BehaviorSubject } from "rxjs";
import { HeaderCalendarComponent } from '../../header-calendar/header-calendar.component';
import { LoadDrupalLangService } from '../../../../../../common-page-components/services/load-drupal-lang.service';
import { RouterFilterReference } from '../../../common/filters-router/filters-router.component';
import { FiltersTypeEnum } from "world-archery-lib";
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/core";
import * as i2 from "../../../../../../common-page-components/services/load-drupal-lang.service";
export class DateFilterComponent extends RouterFilterReference {
    constructor(dateAdapter, drupal_lang_service) {
        super(FiltersTypeEnum.DateFilter);
        this.dateAdapter = dateAdapter;
        this.drupal_lang_service = drupal_lang_service;
        this.customHeader = HeaderCalendarComponent;
        this.subs = [];
        /**
         *
         * Type of format to show date. See Angular DatePipe for options
         * @type {string}
         * @memberof DateFilterComponent
         */
        this.format = "dd/ MMMM /yyyy";
        /**
         *
         * Place holder of input
         * @type {string}
         * @memberof DateFilterComponent
         */
        this.placeholder = "";
        if (this.drupal_lang_service) {
            const lang = LoadDrupalLangService.getRawLang();
            if (lang) {
                this.dateAdapter.setLocale(lang);
            }
        }
    }
    ngOnInit() {
        if (this.dateFormControl === undefined) {
            this.dateFormControl = new FormControl(new Date());
        }
        if (this.date_subject === undefined) {
            this.date_subject = new BehaviorSubject({});
        }
        this.subs.push(this.date_subject
            .asObservable()
            .subscribe(next => (this.date = next.value ? next.value : undefined)));
    }
    onChange(event) {
        this.changeData.emit(event);
        this.date_subject.next(event);
    }
    ngOnDestroy() {
        this.subs.forEach(value => value.unsubscribe());
    }
    /**
     * Method for open calendar when clicked in input
     *
     * @memberof DateFilterComponent
     */
    open() {
    }
}
DateFilterComponent.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DateFilterComponent_Factory() { return new DateFilterComponent(i0.ɵɵinject(i1.DateAdapter), i0.ɵɵinject(i2.LoadDrupalLangService, 8)); }, token: DateFilterComponent, providedIn: "root" });
